<template>
  <div class="main_center resultNoticeList" style="padding: 18px;">
    <div class="content" style="padding: 0 16px;">
      <searchBox :dialogVisible.sync="moreSearchItem" @dialogCancle="dialogCancle" title="更多筛选">
        <div class="search-drawer">
          <el-form :model="form" label-position="top" ref="form">
            <el-form-item label="文件标题：">
              <el-input clearable placeholder="文件标题" v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="发布状态：">
              <el-select clearable style="width:100%;" v-model="form.publishFlag">
                <el-option label="未发布" value="0"></el-option>
                <el-option label="已发布" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发布栏目：" prop="publishColumn" size="small">
              <el-select v-model="form.publishColumn" value-key="value">
                <el-option v-for="(item,index) in publishColumnOption" :key="index" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="search-drawer__footer">
            <el-button @click="searchBtn" size="small" type="primary">查询</el-button>
            <el-button @click="refresh" plain size="small">重置</el-button>
          </div>
        </div>
      </searchBox>
      <div class="search-content">
        <div class="searchBtn">
          <span class="label-form">文件标题：</span>
          <el-input
                  @keyup.enter.native="searchBtn"
                  clearable
                  placeholder="请输入内容搜索"
                  style="width: 300px"
                  v-model="form.title"
          ></el-input>
          <el-button @click="searchBtn" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
          <el-button
                  @click="moreSearchItem = true"
                  icon="el-icon-arrow-down"
                  size="mini"
                  type="text"
          >更多搜索</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
        </div>
      </div>
      <el-button
              style="margin-bottom: 8px"
              @click="routerAdd"
              size="small"
              type="primary"
              v-if="hasBtnPermission('btn_infomationPublish_edit')"
      >新增</el-button>
      <el-table
        :data="tableData"
        :header-cell-style="this.$globalGrayTableHeaderStyle"
        border
        stripe
        :height="tableMaxHeight">
        <el-table-column
          fixed
          label="序号"
          type="index"
          width="50"
          align="left"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
                label="发布状态"
                prop="publishFlag"
                align="left"
                width="130px"
                show-overflow-tooltip
        >
          <template slot-scope="scope">
            <i :class="formatterStatusClass(scope.row.publishFlag)"></i>
            <span>{{scope.row.publishFlag?'已发布':'未发布'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="文件标题"
          prop="title"
          header-align="left"
          align="left"
          min-width="200"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
                label="发布人"
                prop="publishUser"
                header-align="left"
                align="left"
                min-width="170"
                :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
                label="发布栏目"
                prop="publishColumnName"
                header-align="left"
                align="left"
                min-width="170"
                :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
                label="创建时间"
                prop="createTime"
                header-align="left"
                align="left"
                min-width="170"
                :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
                label="修改时间"
                prop="updateTime"
                header-align="left"
                align="left"
                min-width="170"
                :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="操作" fixed="right" align="left" width="150">
          <template slot-scope="scope">
            <el-button
                    type="text"
                    size="small"
                    @click="changeSingle(scope.row.id,'view')"
            >查看</el-button>
            <el-button
              type="text"
              size="small"
              @click="changeSingle(scope.row.id)"
              v-if="hasBtnPermission('btn_infomationPublish_edit') && !scope.row.publishFlag"
              >修改</el-button
            >
            <el-button
              type="text"
              size="small"
              title="删除"
              @click="deleteById(scope.row)"
              v-if="hasBtnPermission('btn_infomationPublish_delete') && !scope.row.publishFlag"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <paginationCom
        @sizechange="sizeChangeHandle"
        @pagechange="pageChangeHandle"
        class="limit"
        :options="paginationOpt"
      ></paginationCom>
    </div>
  </div>
</template>

<script>
import { getInfomationPublishListData, deleteInfomationPublishData } from "@/server/mainCredit.js";
import {mapState} from "vuex";
export default {
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 200 - 106,
      form: {
        historyid: null,
        warnContent: "",
        title: "",
        type: "",
        time: [],
        publishColumn:""
      },
      moreSearchItem:false,
      paginationOpt: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [10, 20, 50],
      },
      tableData: [],
    };
  },
  computed: {
    ...mapState({
      publishColumnOption: (state) => {
        return state.dataDictionary.publishColumnOption;
      },
    }),
  },
  activated() {
    this.getData();
  },
  mounted() {
    this.$store.dispatch("dataDictionary/getPublishColumnOption");
    this.getData();
  },
  methods: {
    refresh() {
      this.pageIndex = 1;
      this.form = {
        historyid: null,
        warnContent: "",
        title: "",
        type: "",
        time: [],
      };
      this.searchBtn();
    },
    searchBtn() {
      //搜索按钮
      this.moreSearchItem = false;
      if (this.form.historyid == "") {
        this.form.historyid = null;
      }
      this.pageIndex = 1;
      this.getData();
    },
    dialogCancle() {
      this.moreSearchItem = false;
    },
    formatterStatusClass(historyId) {
      switch (historyId) {
        case 0:return "icon-point icon-point-verificationing";break;
        case 1:return "icon-point icon-point-success";break;
        case 2:return "icon-point icon-point-info";break;
        case false:return "icon-point icon-point-verificationing";break;
        case true:return "icon-point icon-point-success";break;
        default:return "";break;
      }
    },
    getData() {
      // 获取列表数据
      getInfomationPublishListData({
        page: this.paginationOpt.pageIndex,
        rows: this.paginationOpt.pageSize,
        searchKey: this.form.title,
        filter:{
          publishFlag:this.form.publishFlag,
          publishColumn:this.form.publishColumn,
        }
      }).then((res) => {
        this.tableData = res.data.rows;
        this.paginationOpt.total = res.data.total;
      });
    },
    // 每页长度改变
    sizeChangeHandle(value) {
      this.paginationOpt.pageSize = value;
      this.paginationOpt.pageIndex = 1;
      this.getData();
    },
    // 当前页改变
    pageChangeHandle(value) {
      this.paginationOpt.pageIndex = value;
      this.getData();
    },
    indexMethod(index) {
      return (
        (this.paginationOpt.pageSize - 1) *
          Number(this.paginationOpt.pageSize) +
        Number(index) +
        1
      );
    },
    deleteById(item) {
      this.$confirm(`确定要删除该数据?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteInfomationPublishData(item.id).then((res) => {
          if (res.data.code == "1") {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
      });
    },

    routerAdd() {
      this.$router.push({
        name: "infomationPublishEdit",
      });
    },

    changeSingle(id,viewFlag) {
      let routerName = 'infomationPublishEdit'
      if(viewFlag == 'view'){
        routerName = 'infomationPublishDetail'
      }
      this.$router.push({
        name: routerName,
        query: { id },
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
